import { createAction, props } from '@ngrx/store';
import { QueryParam, } from '../../model/user-page-model';
import { UserStateInitial } from '../user-data.state';
import { ErrorModel } from '@spartacus/core';

export const loadUsersTableData = createAction(
  '[TableData] Update Users',
  props<{ queryText: QueryParam }>()
);

export const loadUsersTableDataFail = createAction(
  '[userData] Check User data Fail',
  props<{ payload: ErrorModel }>()
);

export const loadUsersTableDataSuccess = createAction(
  '[userData] Check User data Success',
  props<{ b2bCustomers: UserStateInitial }>()
);
